module.exports = __webpack_public_path__ + "static/img/161_TO8_1894_og.b56e42d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/161_TO8_1894_og.jpg
// module id = 2Ptk
// module chunks = 0